import AtmEditEventPageRedirector from '../redirectors/AtmEditEventPageRedirector';
import CalendarPageRedirector from '../redirectors/CalendarPageRedirector';
import ObservationReportPageRedirector from '../redirectors/ObservationReportPageRedirector';
import ObservationReportViewPageRedirector from '../redirectors/ObservationReportViewPageRedirector';
import { REDIRECT_PAGE_TYPES } from './redirectPageTypes';

export const PAGE_TYPE_TO_COMPONENT_TYPE = {
  [REDIRECT_PAGE_TYPES.CALENDAR_WITH_DATE]: CalendarPageRedirector,
  [REDIRECT_PAGE_TYPES.EDIT_EVENT_PAGE]: AtmEditEventPageRedirector,
  [REDIRECT_PAGE_TYPES.OBSERVATION_REPORT]: ObservationReportPageRedirector,
  [REDIRECT_PAGE_TYPES.VIEW_OBSERVATION_REPORT]: ObservationReportViewPageRedirector
};
